<template>
  <tr class="anz-bb-no-last-child">
    <td class="anz-hidden-sm anz-block anz-table__cell-spaceless">
      <a-button
        @click="isActive = !isActive"
        className="anz-link anz-strong anz-flex anz-align-items-center anz-justify-content-between anz-py-s"
        :class="{ 'anz-color-primary': isActive }"
      >
        <template #title>
          {{ user.nickname }}
          <a-icon
            v-if="!isActive"
            class-name="anz-color-primary anz-ml-xs"
            name="chevron-down"
            height="1em"
            width="1em"
          />
          <a-icon
            v-else
            class-name="anz-color-primary anz-ml-xs"
            name="chevron-up"
            height="1em"
            width="1em"
          />
        </template>
      </a-button>
    </td>
    <td class="anz-hidden-mo">
      <strong class="anz-strong">
        <a-button
          add-href
          :href="generateProfileRoute(user)"
          :title="user.nickname"
          className="anz-link anz-strong"
        />
      </strong>
    </td>
    <td class="anz-align-center anz-fs-xxs anz-hidden-mo">
      {{ formatDateTime(user.activity.lastActivityDate) }}
    </td>
    <td class="anz-align-center anz-fs-xxs anz-hidden-mo">
      {{ user.stats.visiblePosts }}
    </td>
    <td class="anz-align-center anz-fs-xxs anz-hidden-mo">
      <a-button
        v-if="user.blog.link"
        :title="$translate('profile.labels.blogger')"
        className="anz-link anz-badge anz-badge-gray anz-badge-sm anz-text-uppercase"
        add-href
        target-blank
        :href="user.blog.link"
      />
    </td>
    <td class="anz-align-center anz-fs-xxs anz-hidden-mo">
      <slot name="desktop-actions"> </slot>
    </td>
    <td
      class="anz-block anz-hidden-sm anz-table__cell-spaceless"
      :class="{ 'anz-hidden': !isActive }"
    >
      <table class="anz-table">
        <thead>
          <tr>
            <th class="anz-align-center anz-fs-xxxs">
              {{ $translate('profile.labels.lastActivity') }}
            </th>
            <th class="anz-align-center anz-fs-xxxs">
              {{ $translate('profile.labels.postCount') }}
            </th>
            <th class="anz-align-center anz-fs-xxxs">
              {{ $translate('profile.labels.blogger') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td class="anz-align-center anz-fs-xxs">
              {{ formatDateTime(user.activity.lastActivityDate) }}
            </td>
            <td class="anz-align-center anz-fs-xxs">
              {{ user.stats.visiblePosts }}
            </td>
            <td>
              <a-button
                v-if="user.blog.link"
                :title="$translate('profile.labels.blogger')"
                className="anz-link anz-badge anz-badge-gray anz-badge-sm anz-text-uppercase"
                add-href
                :href="user.blog.link"
              />
            </td>
          </tr>
        </tbody>
      </table>
      <slot name="mobile-actions"> </slot>
    </td>
  </tr>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import AButton from '@/components/Forms/AButton.vue'
import AIcon from '@/components/AIcon.vue'
import { DateTimeHelper } from '@/helper/dateTime'
import { useRouter } from '@/routing/router'

export default defineComponent({
  name: 'UserItem',
  components: {
    AButton,
    AIcon,
  },
  data() {
    return {
      isActive: false,
    }
  },
  props: {
    user: {
      type: Object,
      default: {},
    },
  },
  methods: {
    formatDateTime(date: string) {
      return DateTimeHelper.formatDateTimeFromString(date)
    },
  },
  setup() {
    return {
      ...useRouter(),
    }
  },
})
</script>
